export default __webpack_public_path__ + "static/media/skins.f5fb4e9c.png";